import * as React from 'react';

import { ReactFCC } from '@notino/react-styleguide';

import { ShadeDrawerArgs } from './model';
import { ShadeListButton } from './styled';
import { useShadesDrawer } from './useShadesDrawer';

const ShadesDrawerButton: ReactFCC<ShadeDrawerArgs> = ({
  children,
  ...rest
}) => {
  const { handleOpenDrawer } = useShadesDrawer(rest);

  return (
    <ShadeListButton onClick={handleOpenDrawer} data-testid="ShadeListButton">
      {children}
    </ShadeListButton>
  );
};

export default ShadesDrawerButton;
